import { Typography } from "@circle-react-uikit/Typography";
import type { ReactNode } from "react";

import { useNavContext } from ".";

interface NavGroupContentProps {
  children: ReactNode;
  title: string;
}

export const NavGroupContent = ({ title, children }: NavGroupContentProps) => {
  const { isActive } = useNavContext();
  if (!isActive) {
    return null;
  }

  return (
    <>
      <Typography.TitleSm weight="semibold">{title}</Typography.TitleSm>
      <div
        className="mt-3 flex flex-col space-y-px"
        data-testid="nav-group-content"
      >
        {children}
      </div>
    </>
  );
};
